import React from 'react';
import ConfirmMailContent from '../../authentication/ConfirmMailContent';

const ConfirmMail = () => (
  <div className="text-center">
    <ConfirmMailContent email="xyz@abc.com" />
  </div>
);

export default ConfirmMail;
